import React from "react";
import './Venue.css';
import { Container} from "react-bootstrap";

const Venue = () => {
    return (
        <div class="venue text-center container-styling">
            <div class="title-padding top-header">
                <h1>Venue</h1>
            </div>
            <Container className="py-5">
                <p className="venue-description">
                    We're thrilled to celebrate our wedding at Rhyse Farm, a captivating exclusive-use venue nestled in the heart of the Worcestershire countryside, just outside Tenbury Wells. 
                </p>
                <p className="venue-description">
                    We fell in love with Rhyse Farm's enchanting ambiance and its endless possibilities for creating a truly personalized celebration. We can't wait to share this special place with you as we embark on this exciting new chapter together!
                </p>
                <h3 className="find-venue-title">Finding Rhyse Farm</h3>
                <p className="find-venue-address">
                    Rhyse Lane, Tenbury Wells, Worcestershire, WR15 8NH
                </p>
                <b>Train</b>
                <p>
                    Nearest train stations: <strong>Ludlow</strong> (12 miles - 22 minutes) or <strong>Leominster</strong> (12 miles - 21 minutes)
                </p>
                <b> Taxi</b>
                <p>We recommend booking a taxi in advance. Here are some local taxi services: </p>
                <ul>
                    <li>Tenbury Taxis: 07971482111</li>
                    <li>Ahford Taxis: 07968890696</li>
                    <li>Wolf Cars: 01584856690</li>
                    <li>Caynham Cars: 07715680477</li>
                </ul>
                <b>Coach</b>
                <p> A coach will be available to transport guests from the venue to various local accommodation locations at the end of the night (around 12:00 AM). Here are the locations we'll be serving:</p>
                <ul>
                    <li>Travelodge Ludlow Woofferton</li>
                    <li>Salwey Arms, Woofferton</li>
                    <li>The Church Inn, Ludlow</li>
                    <li>The Feathers Hotel, Ludlow</li>
                    <li>The Townhouse, Ludlow</li>
                    <li>The Charlton Arms Hotel, Ludlow</li>
                    <li>The Cliffe at Dinham, Ludlow</li>
                </ul>
                <p>Please let us know if you need a seat on the coach, but only do so after you have booked your accommodation.</p>
                <p className="find-venue-instructions">
                    For your navigation convenience, we recommend using a map app and searching for "Rhyse Farm, Tenbury Wells" or clicking the "View larger map" button on the map below.
                </p>
            </Container>
            <Container className="pb-3">
            <div class="google-map">
                <iframe 
                    title="Rhyse Farm Map"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d19514.91470046727!2d-2.574426682924851!3d52.30939099999999!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48705dccd6b5756b%3A0xfc98b3084d38fd33!2sRhyse%20Farm!5e0!3m2!1sen!2suk!4v1721849557822!5m2!1sen!2suk&z=1" 
                    width="400" height="300" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                </iframe>
            </div>
            </Container>
        </div>
        
    );
}

export default Venue;